import './page-back.scss';

import ChevronDownIcon from '@/media/icons/chevron-down.svg?react';

interface IProps {
  label: string;
  onBack: () => void;
}

const PageBack: React.FC<IProps> = ({ label, onBack }) => {
  return (
    <button type="button" className="page-back" onClick={onBack}>
      <ChevronDownIcon className="page-back__icon" aria-hidden="true" />
      {label}
    </button>
  );
};

export default PageBack;
